@if (displayRank) {
  <ngb-rating class="rating" [(rate)]="rank" [readonly]="true" [max]="4">
    <ng-template let-fill="fill">
      <span class="dollar" [class.filled]="fill === 100">$</span>
    </ng-template>
  </ngb-rating>
} @else {
  {{ value | currency }}
}
